import FilterSidebar from '@components/FilterSidebar/FilterSidebar';
import React, { FunctionComponent, useEffect } from 'react';
import { getList } from '@stores/experiments';
import css from './ExperimentsListRoute.module.less';
import ExperimentsTable from '@components/ExperimentsTable';
import ExperimentsFilters from '@components/ExperimentsFilters';

interface ExperimentsListRouteProps {}

const ExperimentsListRoute: FunctionComponent<ExperimentsListRouteProps> = () => {
  useEffect(() => {
    getList();
  }, []);

  return (
    <div className={css.root}>
      <FilterSidebar>
        <ExperimentsFilters />
      </FilterSidebar>
      <ExperimentsTable />
    </div>
  );
};

export default ExperimentsListRoute;
